import React from 'react';
import './LocationSpan.scss';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';

const labelMultipleVenues = {
  displayName: 'Flera Orter',
  formattedName: 'event.multiplevenues',
};

const LocationSpan: React.SFC<{
  venue?: string;
  city?: string;
  isMultipleVenues: boolean;
}> = ({
  venue,
  city,
  isMultipleVenues,
}) => {

  if (isMultipleVenues) {
    return <FormattedText style='locationspan' { ...labelMultipleVenues } />;
  }

  if (!venue || !city) {
    return null;
  }

  return (
    <span className='locationspan'>
      { venue }<span className='thinner'>, { city }</span>
    </span>
  );
};

export default LocationSpan;


// WEBPACK FOOTER //
// ./src/components/Shared/LocationSpan/LocationSpan.tsx